import { ProductInfo } from "@insite/client-framework/Common/ProductInfo";
import { SafeDictionary } from "@insite/client-framework/Common/Types";
import {
    ApiHandler,
    createHandlerChainRunner,
    createHandlerChainRunnerOptionalParameter,
    Handler,
} from "@insite/client-framework/HandlerCreator";
import {
    getSubscriptionProducts,
    mySubscribedProducts,
    mySubscriptionProducts,
} from "@TKCCP/Services/tkccpSubscriptionProductsService";
import { CustomApiHandler } from "@TKCCP/Store/CustomHandlerCreator/CustomHandlerCreator";
import { getSubscribedProducts, products } from "@TKCCP/Types/ApiModels";

type Props = {
    CustomerId: string;
    UserProfileId: string;
};

type HandlerType = CustomApiHandler<mySubscriptionProducts, Props>;

// export const DispatchBeginLoadSubscriptionProduct: HandlerType = props => {
//     props.dispatch({
//         type: "Data/SubsriptionProductService/BeginLoadSubsriptionProduct" as any,
//         parameter: props.parameter,
//     });
// };

export const PopulateApiParameter: HandlerType = props => {
    props.apiParameter = props.parameter;
};

export const RequestDataFromApi: HandlerType = async props => {
    try{
        props.apiResult = await mySubscribedProducts(props.apiParameter);
    } catch(error){
        console.log(error)
    }
};

export const DispatchCompleteLoadSubscriptionProduct: HandlerType = props => {
    props.dispatch({
        type: "Data/SubsriptionProductService/getSubscribedProducts",
        collection: props.apiResult,
    });
};

// export const DispatchInitalSubscriptionProduct: HandlerType = props => {
//     props.dispatch({
//         type: "Data/SubsriptionProductService/InitalValuesProduct",
//     });
// };

export const chain = [
    // DispatchBeginLoadSubscriptionProduct,
    PopulateApiParameter,
    RequestDataFromApi,
    DispatchCompleteLoadSubscriptionProduct,
    // DispatchInitalSubscriptionProduct,
];

const getSubscribedProductData = createHandlerChainRunner(chain, "getSubscribedProduct");
export default getSubscribedProductData;
